// Exposes the current user's per-user wholesale-price visibility preference so
// any component rendering prices can gate on a single source of truth.
// `showWholesalePrice` is false when the user has toggled prices off.
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      showWholesalePrice: 'auth/showWholesalePrice'
    })
  }
}
